import { MoonStar, Sun } from 'lucide-react'
import { brand as bmcBrand } from '@/ui/brand'
import { useTheme } from '../../contexts/ThemeContext'
import { AdminUserMenu } from './AdminUserMenu'
import type { Session } from '../../types'

/**
 * Kopfzeile der Admin-Konsole (`.shell` aus console.css): theme-abhängiges
 * BMC-Logo + Wortmarke „vCard · Konsole", Theme-Umschalter (`.icon-btn`) und
 * das UserMenu (`.avatar-btn`).
 */
export function AdminHeader({ session }: { session: Session }) {
  const { theme, toggle } = useTheme()
  const logo = theme === 'dark' ? bmcBrand.logoDark : bmcBrand.logoLight
  return (
    <header className="shell">
      <div className="wordmark">
        <img src={logo} alt={bmcBrand.name} className="brand-logo" />
        <span className="name">
          {bmcBrand.product} <span className="suffix">· Konsole</span>
        </span>
      </div>
      <span className="spacer" />
      <button
        type="button"
        className="icon-btn"
        aria-label="Design wechseln"
        aria-pressed={theme === 'dark'}
        onClick={toggle}
      >
        {theme === 'dark' ? <Sun size={18} /> : <MoonStar size={18} />}
      </button>
      <AdminUserMenu session={session} />
    </header>
  )
}
